import { themeService } from '../../../services/theme/ThemeService';
import { withThemeLoader } from '../../../decorators/withThemeLoader';

export class ToBuildAProfileLoader {
  
  static Layout = null;
  
  static theme = themeService.THEMES.THEME_TO_BUILD_A_PROFILE;
  
  static async load(callback) {
    await import(/* webpackChunkName: "2bap-theme" */ '2bap/index.less');
  
    if (!ToBuildAProfileLoader.Layout) {
      ToBuildAProfileLoader.Layout =
        withThemeLoader(require('./layouts/ModuleLayout').default, ToBuildAProfileLoader.theme);
    }
    callback(null, ToBuildAProfileLoader.Layout);
  }
  
}
